import { Component, Inject } from "@angular/core";
import { UntypedFormBuilder, FormGroup, Validators } from "@angular/forms";
import {  MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Select, Store } from "@ngxs/store";
import { SaveAlert, GetAlerts, AlertDefinition,  CompassAlert, AlertScoreSummary, AlertTrackable, SavePractitionerGroup, PractitionerGroupEntity,  CommonService, GetPractitionerGroups, PractitionerGroupStateModel, CompassStateModel, BulkSubscription, Compass, CompassScaleRange, CompassTrackable, Provider } from 'huddyapi';
import { Observable, Subscription } from "rxjs";
import { SavedProvider } from "../../settings/settings.component";



@Component({
  selector: 'edit-alert-dialog',
  templateUrl: 'edit-alert-dialog.component.html',
  styleUrls: ["./edit-alert-dialog.component.scss"]
})
export class EditAlertDialog  {
  

  edited : Alert;
  provider : Provider;
  compass : Compass;
  icons : any[] = [{'name':'Red', 'value': 'RED'}, {'name':'Yellow', 'value': 'YELLOW'}, {'name':'Green', 'value': 'GREEN'}];
  @Select(state => state.practitionerGroupState) practitionerGroupState$: Observable<PractitionerGroupStateModel>;
  @Select(state => state.compassState) compassState$: Observable<CompassStateModel>;

  practitionerGroupSubscription : Subscription;
  groups : PractitionerGroupEntity[];
  bulkSubcriptions : BulkSubscription[] = [];
  
  scoreSummaryRanges : CompassScaleRange[] = [];
  trackables : EditableTrackable[] = [];
  inclusions : string[] = ['high compass scores', 'trackables with high score ranges'];
  promisInclusions : string[] = ['0-9', '10-19', '20-29', '30-39', '40-49', '50-59', '60-69', '70-79', '80-89', '90-100'];
  promisScaleRanges : CompassScaleRange[] = [
    new CompassScaleRange({ name : "0-9", minimum : 0, maximum : 9}),
    new CompassScaleRange({ name : "10-19", minimum : 10, maximum : 19}),
    new CompassScaleRange({ name : "20-29", minimum : 20, maximum : 29}),
    new CompassScaleRange({ name : "30-39", minimum : 30, maximum : 39}),
    new CompassScaleRange({ name : "40-49", minimum : 40, maximum : 49}),
    new CompassScaleRange({ name : "50-59", minimum : 50, maximum : 59}),
    new CompassScaleRange({ name : "60-69", minimum : 60, maximum : 69}),
    new CompassScaleRange({ name : "70-79", minimum : 70, maximum : 79}),
    new CompassScaleRange({ name : "80-89", minimum : 80, maximum : 89}),
    new CompassScaleRange({ name : "90-100", minimum : 90, maximum : 100})

  ];
  compassControlId : number;

  alertDefinitionForm = this.formBuilder.group({
    name: ['', [Validators.required, Validators.maxLength(50)]],
    text: ['', [Validators.required, Validators.maxLength(50)]],
    icon: ['', [Validators.required]],
    practitionerGroups : ['', [Validators.required, Validators.minLength(1)]],
    inclusions : ['', [Validators.required, Validators.minLength(1)]]
});

  constructor(
    public dialogRef: MatDialogRef<EditAlertDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder : UntypedFormBuilder,
    private common : CommonService,
    public store : Store
  )
  {
    console.log('data', data);
    let selectedGroups : number[] = [];
    if (data.practitionerGroups && data.practitionerGroups.length > 0) {
      selectedGroups = data.practitionerGroups.map(p => p.id);
    }

    let compassId : number = null;
    let scoreRanges : AlertScoreSummary[] = [];
    let trackables : CompassTrackable[] = [];
    let inclusions : string[] = [];
    this.compass = data.sourceCompass;
    console.log('data.sourceCompass=' , data.sourceCompass);
    if (data) {
      console.log('data.compasses=' , data.compasses);
      
      if (data.compasses) {
        let compassAlert : CompassAlert = data.compasses.reduce((prev, current) => (prev.id > current.id) ? prev : current); 
        compassId = compassAlert.compassControlId;
        console.log(this.compass, this.compass.promis);
        this.compassControlId = compassId;

        for (let compass of data.compasses) {
          scoreRanges = scoreRanges.concat(compass.scoreSummaries);
          trackables = trackables.concat(compass.trackables);
        }
      }
      
      if (!this.compass.promis) {
        if (scoreRanges.length > 0) {
          inclusions.push(this.inclusions[0]);
        }
      } else {
        inclusions = scoreRanges.map(sr => sr.scoreSummaryText);
      }
      

      let hasValuedTrackables = (trackables.length > 0)  ;
      if (hasValuedTrackables) {
        if (this.compass.promis) {
          this.promisInclusions.push(this.inclusions[1]);
          inclusions.push(this.inclusions[1]);
        } else {
          inclusions.push(this.inclusions[1]);
        }
      }

      console.log('inclusions', this.compass, scoreRanges, inclusions, hasValuedTrackables, trackables);
    }
  
    this.alertDefinitionForm.setValue({
      name: data.name ?? '',
      text: data.text ?? '',
      icon: data.icon ?? 'red',
      practitionerGroups: selectedGroups,
      inclusions : inclusions
    });

    this.edited = {
      id : data.id,
      name: data.name ?? '',
      text: data.text ?? '',
      icon: data.icon ?? '',
      practitionerGroups : data.practitionerGroups ?? [],
      compasses : data.compasses ?? [],
      sourceCompass : data.sourceCompass
    };


    this.provider = this.data.provider;
    console.log('provider=', this.provider);

  }
 


  ngOnInit(): void {
   console.log(this.edited);
   this.  practitionerGroupSubscription  = this.practitionerGroupState$.subscribe((practitionerGroupState: PractitionerGroupStateModel) => {
    console.log(practitionerGroupState);
    if (practitionerGroupState && practitionerGroupState.groups) {
       this.groups = [].concat(practitionerGroupState.groups);
    }
    console.log(this.groups, this.groups.map(g => g.name));   
    });
    this.store.dispatch(new GetPractitionerGroups(this.provider.id));
    this.compassState$.subscribe((model: CompassStateModel) => {
      this.bulkSubcriptions = model.subscriptions.filter(b => b.providerId === this.provider.id);
      if (this.compassControlId) {
        this.compass = this.bulkSubcriptions.map(bs => bs.compass).filter(c => c.versionControlId === this.compassControlId)[0];
      }
      console.log('Bulksubscriptions', this.bulkSubcriptions);
    });
  }

  isFormInValid() {
    return (this.alertDefinitionForm.invalid);
  }

  onCompassSelected($event) {
    let compassId : number = $event.value;
    let subscription : BulkSubscription = this.bulkSubcriptions.find(b => b.compass.versionControlId === compassId);
    if (subscription) {
      this.compass = subscription.compass;     
      console.log('compass', this.compass, this.scoreSummaryRanges, this.trackables);
    }
  }

  onSubmitForm(treatmentForm) {
   this.save();
  }

  close() {
     
      this.dialogRef.close();
  }


  save() {
      console.log('entering save');
      
      let alertScoreSummaries  : AlertScoreSummary[] = [];
      let selectedInclusions : string[] = this.alertDefinitionForm.value.inclusions;
      console.log('inclusions', selectedInclusions, this.compass);
      if (this.compass.promis) {
        let rangeInclusions : string[] = selectedInclusions.filter(i => i != this.inclusions[1]);
        if (rangeInclusions.length > 0) {
          for (let inclusion of rangeInclusions) {
            let range : CompassScaleRange[] = this.promisScaleRanges.filter(r => r.name === inclusion);
            if (range.length > 0) {
              alertScoreSummaries.push( {
                compassControlId : this.compass.versionControlId,
                scoreSummaryText : range[0].name,
                min : range[0].minimum,
                max : range[0].maximum
              });
            }
          }
        }
      } else if (selectedInclusions.includes(this.inclusions[0]) && this.compass.scoreSummaryRanges && this.compass.scoreSummaryRanges.length > 0) {
       const max = this.compass.scoreSummaryRanges.reduce((prev, current) => (prev.maximum > current.maximum) ? prev : current); 
        let a : AlertScoreSummary = {
          compassControlId : this.compass.versionControlId,
          scoreSummaryText : max.name,
          min : max.minimum,
          max : max.maximum
        };
        alertScoreSummaries.push(a);
      }
     
      let trackables  : AlertTrackable[] = [];
      if (selectedInclusions.includes(this.inclusions[1]) && this.compass.trackables && this.compass.trackables.includes.length > 0) {
        for (let t of this.compass.trackables) {
          if (t.trackableValuations && t.trackableValuations.length > 0) {
            for (let v of t.trackableValuations) {
              if (v.scale && v.scale.length > 0) {
                let max = v.scale.reduce((prev, current) => (prev.maximum > current.maximum) ? prev : current);
                let trackable : AlertTrackable = {
                  trackableSourceId : t.trackableId,
                  trackableName : t.name,
                  trackableType : t.trackableType,
                  compassControlId : this.compass.versionControlId,
                  min : max.minimum,
                  max : max.maximum
                };
                trackables.push(trackable);
              }
            }
          }
          
        }
      }
      let c : CompassAlert = {
        compassControlId : this.compass.versionControlId,
        compassName : this.compass.name,
        providerName : this.compass.providerName,
        scoreSummaries : alertScoreSummaries,
        trackables: trackables
      };
      let compasses : CompassAlert[] = [c];
      let g : AlertDefinition = ({
        id: (this.edited.id && this.edited.id > -1) ? this.edited.id : null,
        compassId : this.compass.id,
        name : this.alertDefinitionForm.value.name,
        text :  this.alertDefinitionForm.value.text,
        icon : this.alertDefinitionForm.value.icon, 
        providerId : this.provider.id,
        practitionerGroups : this.groups.filter(group => this.alertDefinitionForm.value.practitionerGroups.indexOf(group.id > -1)),
        compasses : compasses
      });

     
    console.log('Alert to save', g);  
    this.store.dispatch(new SaveAlert(g)).subscribe(t => {
          this.store.dispatch(new GetAlerts(this.provider.id));
          this.close();
        });
  }

  getInclusions() : string[] {
    return this.compass && this.compass.promis ? this.promisInclusions : this.inclusions;
  }

}

export interface Alert {
  id : number;
  name: string;
  text: string;
  icon: string;
  compasses: CompassAlert[];
  sourceCompass : Compass;
  practitionerGroups: PractitionerGroupEntity[];
}

export interface EditableTrackable {
  id : number;
  name : string;
  maximum : number;
  minimum : number;
  included : boolean;
}